export default {
  zh: {
    newTitle: '添加新任务',
    editTitle: '编辑任务',
    viewTitle: '查看任务',
    labels: {
      assignTo: '任务分配给',
      status: '状态',
      subject: '主题',
      priority: '优先级',
      dueDate: '截止日期',
      comments: '评论',
      moreOptions: '更多选项...',
      recentOptions: '最近选择过',
      relatedTo: '相关者',
      phone: '电话',
      email: '邮件',
    },
  },
  en: {
    newTitle: 'Add New Task',
    editTitle: 'Edit Task',
    viewTitle: 'View Task',
    labels: {
      assignTo: 'Assign To',
      status: 'Status',
      subject: 'Subject',
      priority: 'Priority',
      dueDate: 'Due Date',
      comments: 'Comments',
      moreOptions: 'More options...',
      recentOptions: 'Recent Selections',
      relatedTo: 'Related To',
      phone: 'Phone',
      email: 'Email',
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/page/TaskDetails/i18n.js